<template>
  <div class="google-wrap" :style="{'align-items':align}">
    <p v-if="showOr">{{$t('messages.gLogin.text')}}</p>
    <div id="g_id_onload"
      data-client_id="905340330685-adl9881j2nm0bp9qabve0rncfi5ac9up.apps.googleusercontent.com"
      data-context="signin"
      data-ux_mode="redirect"
      :data-login_uri="`${baseUrl}/api/accounts/login-with-google/?${query}`"
      data-auto_prompt="false"
      data-auto_select="false"
      >
    </div>
    <div
      ref="googleSignInBtn"
      class="google-signin-btn"
      ></div>
  </div>
</template>

<script>
const GOOGLE_CLIENT_ID = '905340330685-adl9881j2nm0bp9qabve0rncfi5ac9up.apps.googleusercontent.com'

export default {
  data(){
    return {
      baseUrl:'',
    }
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    align:{
      type: String,
      default: 'center',
    },
    showOr: {
      type: Boolean,
      default: true,
    },
    type:{
      type:Number,
      default:1,// 1 login ,2 sign up
    },
    query: {
      type: String,
      default: 's=Official',
    },
  },
  computed: {
    googleLocale() {
      return this.$i18n.locale === 'zh' ? 'zh_CN' : 'en'
    },
  },
  watch: {
    '$i18n.locale'() {
      this.$nextTick(() => this.setupGoogleBtn())
    },
    type() {
      this.$nextTick(() => this.setupGoogleBtn())
    },
    query() {
      this.$nextTick(() => this.setupGoogleBtn())
    },
  },
  created(){
    if(document.domain.indexOf('asogrow-release.offers-test.adxmi.com')>-1){
      this.baseUrl = 'https://asogrow-release.offers-test.adxmi.com'
    }else{
      this.baseUrl = 'https://app.asogrow.net'
    }
  },
  mounted() {
    this.setupGoogleBtn()
  },
  beforeDestroy() {
    const el = this.$refs.googleSignInBtn
    if (el) {
      el.innerHTML = ''
    }
  },
  methods: {
    getGoogleScriptSrc() {
      return `https://accounts.google.com/gsi/client?hl=${this.googleLocale}`
    },
    ensureGoogleScript(callback) {
      const src = this.getGoogleScriptSrc()
      const existing = document.querySelector('script[data-google-gsi="true"]')
      if (existing && existing.src === src && window.google && window.google.accounts && window.google.accounts.id) {
        callback()
        return
      }
      if (existing) {
        existing.remove()
      }
      const script = document.createElement('script')
      script.src = src
      script.dataset.googleGsi = 'true'
      script.onload = callback
      document.body.appendChild(script)
    },
    setupGoogleBtn() {
      this.ensureGoogleScript(() => {
        if (!window.google || !window.google.accounts || !window.google.accounts.id) {
          return
        }
        window.google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          ux_mode: 'redirect',
          login_uri: `${this.baseUrl}/api/accounts/login-with-google/?${this.query}`,
          auto_select: false,
        })
        const el = this.$refs.googleSignInBtn
        if (!el) {
          return
        }
        el.innerHTML = ''
        window.google.accounts.id.renderButton(el, {
          type: 'standard',
          shape: 'circle',
          theme: this.type === 1 ? 'outline' : 'filled_blue',
          text: this.type === 1 ? 'signin_with' : 'signup_with',
          size: 'medium',
          logo_alignment: 'center',
          width: this.type === 1 ? 300 : 185,
          locale: this.googleLocale,
        })
      })
    },
  },
}
</script>

<style lang="scss">
  .google-wrap{
    display: flex;
    flex-direction: column;
    align-items: center !important;
    >p{
      margin-bottom: 16px;
      font-size: 16px;
      font-weight: 400;
      color: #606266;
      line-height: 24px;
      text-align: center;
      width: 100%;
    }
    .nsm7Bb-HzV7m-LgbsSe.JGcpL-RbRzK.pSzOP-SxQuSe{
      margin: 0 auto !important;
    }
    .nsm7Bb-HzV7m-LgbsSe .nsm7Bb-HzV7m-LgbsSe-BPrWId{
      font-size: 14px !important;
    }
  }
</style>
